function e(n, r) {
  var d;
  return (d = n.outletStocks) == null ? void 0 : d.find(
    (a) => (a == null ? void 0 : a.outletId) === r
  );
}
export {
  e as default
};
